<template>
  <div class="p-main">
    <div class="p-main__left">
      <side-nav />
    </div>
    <div class="p-main__right">
      <div class="p-main__right__bar">
        <div v-if="userInfo" class="p-main__right__user">
          <nav-bar />
          <user-info :user-name="userInfo.email" @detail="handleAccountDetail" @updatePsw="handleUpdatePsw" />
        </div>
      </div>
      <div v-loading="loading" class="p-main__right__content">
        <div v-if="title" class="p-main__right__content__title">{{ title }}</div>
        <router-view
          @openService="handleServiceShow"
          @loading="handleLoadingStatus(true)"
          @cancelLoading="handleLoadingStatus(false)"
        />
      </div>
    </div>

    <data-export-center ref="exportCenter" />
  </div>
</template>

<script>
import DataExportCenter from '@component/data-export-center/index';
import SideNav from '@component/sideNav/index';
import NavBar from '@component/navBar/index';
import UserInfo from '@component/userInfo/index';
import loadingMixin from '@/mixins/loading';
import { mapState, mapGetters } from 'vuex';
import { Service } from '@polyv/polyv-ui';
export default {
  components: {
    SideNav,
    UserInfo,
    NavBar,
    DataExportCenter
  },
  mixins: [loadingMixin],
  computed: {
    ...mapState({
      customInfo: (state) => state.account.customInfo,
    }),
    ...mapGetters({
      userInfo: 'account/accountInfo'
    }),
    title() {
      if (this.$route.meta.isSubAccount) return;
      return this.$route.meta.title;
    },
  },

  watch: {
    customInfo: {
      handler(newVal, oldVal) {
        const { customBrandEnabled, customerToolEnabled } = newVal ?? {};
        const { customBrandEnabled: oldBrandEnabled, customerToolEnabled: oldToolEnabled } = oldVal ?? {};
        if ((oldBrandEnabled === customBrandEnabled && oldToolEnabled === customerToolEnabled) || (!customBrandEnabled && !customerToolEnabled)) return;
        if (!this.ynToBool(customBrandEnabled || 'N') || (this.ynToBool(customBrandEnabled || 'N') && this.ynToBool(customerToolEnabled || 'N'))) {
          Service.init({
            name: this.userInfo.company,
            email: this.userInfo.email,
            phone: this.userInfo.phone,
            c_cf_qq: this.userInfo.qq
          });
        }
      },
      immediate: true,
    }
  },
  mounted() {
    this.getBillDictionary();
  },
  methods: {
    async getBillDictionary() {
      const billDictionary = await this.$store.dispatch('account/getBillDictionary');
      this.$store.commit('account/setBillDictionary', billDictionary);
    },
    handleServiceShow() {
      this.$Service.show();
    },
    handleAccountDetail() {
      this.$router.push('/group/accountDetail');
    },
    handleUpdatePsw() {
      this.$router.push('/group/updatePassword');
    },
  }

};
</script>

<style lang="scss" scoped>
.p-main {
  min-width: 1170px;
  height: 100%;
  display: flex;
  &__right {
    flex: 1;
    display: flex;
    flex-direction: column;
    // overflow: scroll;
    &__bar {
      height: 56px;
      position: relative;
      box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.05);
      background: #fff;
      z-index: 1;
    }
    &__content {
      flex: 1;
      background: #fff;
      overflow: scroll;
      box-sizing: border-box;
      position: relative;
      &__title {
        font-size: 18px;
        font-weight: 500;
        margin: 18px;
      }
    }
    &__user {
      position: absolute;
      right: 20px;
      top: 50%;
      transform: translateY(-50%);
    }
  }
  &__uDesk__entrance {
    position: fixed;
    right: 30px;
    bottom: 30px;
    width: 60px;
    height: 60px;
    text-align: center;
    line-height: 60px;
    background: #2196f3;
    border-radius: 50%;
    &:active {
      opacity: .6;
    }
    .plv-icon {
      width: 34px;
      height: 34px;
      color: #fff;
    }
  }
}
</style>
